import dayjs from 'dayjs';

import { Button, Spinner } from '../../../../components';
import { useMutation } from '@apollo/client';
import { FINALIZE_STRATEGY } from '../../queries';
import { message } from 'antd';
import QueryErrorBoundary from '../../../../components/error-handling';

interface FinalizeStrategyProps {
  strategyId: string;
  onCancel: () => void;
  lastUpdate: string;
}

export function FinalizeStrategy({
  strategyId,
  onCancel,
  lastUpdate,
}: FinalizeStrategyProps) {
  const [FinalizeStrategy, { error }] = useMutation(FINALIZE_STRATEGY, {
    refetchQueries: ['FetchStrategySummary', 'FindAllProcessAreasByLocation'],
  });

  const onFinalize = async () => {
    try {
      const response = await FinalizeStrategy({
        variables: {
          data: {
            uuid: strategyId,
            bcpStatus: 'Finalized',
            finalizedAt: dayjs(),
          },
        },
      });
      if (response.data) {
        message.success('Strategy finalized successfully');
      }
    } catch (error) {
      console.log(error);
      message.error('Failed to finalize strategy');
    } finally {
      onCancel();
    }
  };

  return (
    <QueryErrorBoundary error={error}>
      <div className="flex flex-col flex-nowrap items-center justify-center">
        <p className="my-2   text-sm font-normal text-black tracking-wider text-center">
          Finalizing the strategy will date stamp the strategy with today’s date
          and reset the update timer.
        </p>
        <h3 className="my-2   text-sm font-bold text-black tracking-wider text-center">
          LAST UPDATE: {lastUpdate}
        </h3>
        <Button
          type="primary"
          htmlType={'button'}
          onClick={onFinalize}
          className="my-4 min-w-[180px]"
        >
          Finalize
        </Button>
      </div>
    </QueryErrorBoundary>
  );
}
